import React, { useEffect, useState, useCallback } from 'react'
import { useSpringCarousel } from 'react-spring-carousel'

export default function Carousel ({ disableKeyboard, items, carouselSlideAxis = 'x', onEvent, initialActiveItem = 0 }) {
  if (initialActiveItem < 0) {
    initialActiveItem = 0
  }
  const [indexH, setIndexH] = useState(initialActiveItem); // Horizontal Index
  const {
    carouselFragment,
    slideToItem,
    useListenToCustomEvent
  } = useSpringCarousel({
    carouselSlideAxis,
    initialActiveItem,
    items
  })
  const handleKeyDown = useCallback((event) => {
    // console.log('carousel keydown', event.key, indexH)
    if (event.key === 'ArrowUp') {
      if (indexH - 1 >= 0) {
        setIndexH(indexH - 1)
      }
    } else if (event.key === 'ArrowDown') {
      if (indexH + 1 < items.length) {
        setIndexH(indexH + 1)
      }
    }
  }, [indexH, items]);
  useEffect(() => {
    const handleEvent = (event) => {
      if (disableKeyboard) return; // Early return if keyboard interaction is disabled
      handleKeyDown(event);
    };

    window.addEventListener('keydown', handleEvent);
    return () => {
      window.removeEventListener('keydown', handleEvent);
    };
  }, [disableKeyboard, handleKeyDown]); // Depend on `disableKeyboard` and `handleKeyDown` to re-attach listener correctly
  useEffect(() => {
    slideToItem(indexH)
  }, [indexH])
  useListenToCustomEvent(e => {
    onEvent && onEvent(e)
  })
  return (
    <div className='carousel tiktok w-full relative aspect-square'>
      {carouselFragment}
    </div>
  ) 
}